import React from 'react'
import './styles.scss'

export interface SelectBoxOption {
  id: string | number
  label: string
  value: string
}

interface Props {
  options: SelectBoxOption[]
  onClick: (option: SelectBoxOption) => void | void
  selected?: string | number | null
}

const SelectBox = ({ options, onClick, selected }: Props) => {
  return (
    <div className='select-container'>
      {options.map((option) => (
        <div onClick={() => onClick(option)} key={option.id} className='select-option'>
          <input className='input' type='checkbox' checked={selected === option.id} onChange={() => {}} />
          <span>{option.label}</span>
          {option.id !== 0 && (
            <>
              <span className='separator'>-</span>
              <span className='value'>{option.value}</span>
            </>
          )}
        </div>
      ))}
    </div>
  )
}

export default SelectBox
